import styled from '@emotion/styled';
import React, {useContext, useState} from 'react';
import {ETextInput} from 'webapp-lib/Components';
import {mixinFlexboxRow} from 'webapp-lib/styling';
import {onEnterPress} from 'webapp-lib/utils';

import {EventApiWithWorkLogProps, EventTimers} from '../../types';
import {PlayButton} from '../PlayButton';
import {CalendarAPIContext} from '../TimeTrackerShelf';

import {ElapsedTime} from './ElapsedTime';

export const QuickActivity = ({
  recordingEvent,
  timer,
}: {
  recordingEvent: EventApiWithWorkLogProps | null;
  timer: EventTimers;
}): React.ReactElement => {
  const [quickActivity, setQuickActivity] = useState<string>('');
  const calendarContext = useContext(CalendarAPIContext);

  const isEmpty = quickActivity.trim() === '';
  const isRecording = recordingEvent !== null;

  const handlePlayPressed = () => {
    timer.start({title: quickActivity});
  };
  const handlePausePressed = () => {
    setQuickActivity('');
    timer.stop();
  };

  return (
    <QuickBox>
      <ETextInput
        autoFocus={true}
        disabled={isRecording}
        endAdornment={
          <ButtonRow>
            {isRecording && <ElapsedTime recordingEvent={recordingEvent} />}
            <PlayButton
              disabled={isEmpty && !isRecording}
              isRunning={isRecording}
              startTimer={handlePlayPressed}
              stopTimer={handlePausePressed}
            />
          </ButtonRow>
        }
        inputRef={calendarContext.quickActivityInputRef}
        largeEndAdornment={true}
        placeholder='Woran arbeiten Sie?'
        size='large'
        value={isRecording ? recordingEvent.title : quickActivity}
        onChange={(evt) => setQuickActivity(evt.target.value)}
        onKeydown={onEnterPress(() => handlePlayPressed())}
      />
    </QuickBox>
  );
};

const QuickBox = styled.div`
  padding: var(--gutter-medium);
  padding-bottom: 0;

  .MuiInputBase-root {
    .Mui-disabled {
      color: var(--text-primary-color);
      -webkit-text-fill-color: black;
    }
  }
`;

const ButtonRow = styled.div`
  ${mixinFlexboxRow};
  align-items: center;
`;
